import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const state = {
  order: {
    outfitter: {},
  },
  startDate: "",
  endDate: "",
};

const getters = {
  getOrder: (state) => {
    return state.order;
  },
  getStartDate: (state) => {
    return state.startDate;
  },
  getEndDate: (state) => {
    return state.endDate;
  },
};

const actions = {
  set_start_date({ commit }, startDate) {
    commit("set_start_date", startDate);
  },
  set_end_date({ commit }, endDate) {
    commit("set_end_date", endDate);
  },
  async get_order({ commit }, orderId) {
    const resp = await asyncHandler(
      HTTP({
        url: "order/" + orderId,
        method: "POST",
        data: {},
      })
    );
    if (resp.success) {
      commit("set_order", resp.order);
    }
    return resp;
  },
};

const mutations = {
  set_order: (state, order) => {
    state.order = order;
  },
  set_start_date: (state, startDate) => {
    state.startDate = startDate;
  },
  set_end_date: (state, endDate) => {
    state.endDate = endDate;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
